import apiMiddleware from '../../api/middleware';
import { notificationMiddleware } from "../../notification/middleware";
import { sessionDataMiddleware } from '../../sessionData/middleware';
import cacheMiddleware from "../../cache/middleware";

export const coreMiddleware = [...sessionDataMiddleware, ...notificationMiddleware, apiMiddleware, cacheMiddleware];
